// extracted by mini-css-extract-plugin
export default {"form__container":"styles_form__container__QPtJB"};